import http from '@/plugins/axios_plugin';

class ServiceRemessas {
  index () {
    return http.get('/api/remessas/listar')
  }

  proximoNumero () {
    return http.get('/api/remessas/proximonumero')
  }

  salvar (remessa) {
    return http.post('/api/remessas/salvar', remessa)
  }

  editar (remessa_id) {
    return http.get('/api/remessas/' + remessa_id + '/editar')
  }

  atualizar (remessa_id, post) {
    return http.post('/api/remessas/' + remessa_id + '/atualizar', post)
  }

  cancelar (remessa_id) {
    return http.post('/api/remessas/' + remessa_id + '/cancelar')
  }

  carregarDadosImpressao (remessa_id) {
    return http.get('/api/remessas/' + remessa_id + '/dadosimpressao');
  }
}

export default new ServiceRemessas();